var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star 2",
    d: "M7.32789 1.24769C8.01187 -0.193239 9.98812 -0.193242 10.6721 1.24769L11.8542 3.73799C12.1258 4.31019 12.6508 4.70679 13.2582 4.79854L15.9014 5.19788C17.4309 5.42895 18.0416 7.3831 16.9349 8.50471L15.0222 10.4431C14.5827 10.8885 14.3822 11.5302 14.4859 12.1591L14.9374 14.8963C15.1987 16.48 13.5999 17.6877 12.2319 16.94L9.8677 15.6477C9.32448 15.3508 8.67552 15.3508 8.1323 15.6477L5.7681 16.94C4.40013 17.6877 2.80131 16.48 3.06257 14.8963L3.51409 12.1592C3.61784 11.5302 3.41729 10.8885 2.97782 10.4431L1.06514 8.50471C-0.0415638 7.3831 0.569129 5.42895 2.09856 5.19788L4.74182 4.79854C5.34916 4.70679 5.87418 4.31019 6.14579 3.73799L7.32789 1.24769Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.bdc402c4836d7467c39f3403b375ccc2.svg";
export { ForwardRef as ReactComponent };